import type { LatestProject, LatestProjectCategory, LatestProjectStatus } from '../types/latestProjects';

export type LatestFilter = 'all' | 'ongoing' | LatestProjectCategory;

export const latestFilters: { id: LatestFilter; label: string }[] = [
  { id: 'all', label: 'All Projects' },
  { id: 'ongoing', label: 'Ongoing' },
  { id: 'roads', label: 'Roads & Transport' },
  { id: 'water', label: 'Water & Sanitation' },
  { id: 'mining', label: 'Mining & Earthworks' },
];

const categoryLabels: Record<LatestProjectCategory, string> = {
  roads: 'Roads & Transport',
  water: 'Water & Sanitation',
  mining: 'Mining & Earthworks',
};

const statusLabels: Record<LatestProjectStatus, string> = {
  ongoing: 'Ongoing',
  completed: 'Completed',
  pending: 'Pending confirmation',
};

export const latestCategoryLabel = (category: LatestProjectCategory) => categoryLabels[category];
export const latestStatusLabel = (status: LatestProjectStatus) => statusLabels[status];

export function matchesLatestFilter(project: LatestProject, filter: LatestFilter) {
  if (filter === 'all') return true;
  if (filter === 'ongoing') return project.status === 'ongoing';
  return project.category === filter;
}

export function countLatestByFilter(projects: LatestProject[]) {
  return Object.fromEntries(
    latestFilters.map((f) => [f.id, projects.filter((p) => matchesLatestFilter(p, f.id)).length]),
  ) as Record<LatestFilter, number>;
}

/** Only dates that are actually recorded, in display order. */
export function latestProjectDates(project: LatestProject): [string, string][] {
  return [
    project.startDate ? ['Start date', project.startDate] : null,
    project.expectedCompletion ? ['Expected completion', project.expectedCompletion] : null,
    project.recordedCompletion ? ['Recorded completion', project.recordedCompletion] : null,
    project.contractPeriod ? ['Contract period', project.contractPeriod] : null,
  ].filter(Boolean) as [string, string][];
}

export const publicValues = (project: LatestProject) =>
  project.valueApproved && project.values ? project.values : [];
